import { DataExtractionListItem } from '@/types/entities/DataExtraction';
import { useCheckboxSelection } from '@/hooks/useCheckboxSelection';

export function useDataExtractionCheckSelection(
	tableData: {
		items: DataExtractionListItem[];
		total: number;
		page: number;
		limit: number;
	},
	onClearSelection: () => void
) {
	const {
		totalSelectedCount,
		selectedIds,
		selectedRowKeys,
		isAllSelected,
		isIndeterminate,
		handleMainCheckboxChange,
		handleRowCheckboxChange,
		clearSelection
	} = useCheckboxSelection<DataExtractionListItem>({
		data: tableData.items,
		totalItems: tableData.total,
		onClearSelection,
		getItemId: (item) => item.id
	});

	return {
		totalSelectedCount,
		selectedIds,
		selectedRowKeys,
		isAllSelected,
		isIndeterminate,
		handleMainCheckboxChange,
		handleRowCheckboxChange,
		clearSelection
	};
}
